module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-hero.7c6ce15d.jpg";